import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-summary-card',
  templateUrl: './summary-card.component.html',
  styleUrls: ['./summary-card.component.scss']
})
export class SummaryCardComponent implements OnInit,OnDestroy {
  @Input() title: string;
  @Input() value: string;
  @Input() flex: number = 1;
  @Input() classObject:{ [Class: string]: any; };
  @Input() tooltip:string;
  @Input() isGrid= true;
  private destroy$ = new Subject<void>();
  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
